/*
 * The catchAWave object is the client js library for the catch a wave game
 */


import { getStore } from '../redux/store' 
import { setDockToSide } from "../redux/otuVision/actions"

global.catchAWave = {
	/*
	 * The game object
	 */
	gameData:{},
	gameDataPlayer2:{},
	connectGameState:[],
	connectInviteRoomId:null,
	modeSinglePlayer:0,
	modeTwoPlayerPrimary:1,
	modeTwoPlayerSecondary:2,	
	player2UserId : null,
	stateNotStarted:0,
	stateStarted:2,
	stateError:4,
	stateGameOver:5,
	
	timers:[],
	killingTimers:false,
	UIflexYourMuscleCreditAwardedFlag:false,
	UIChestOpenAwardedFlag:false,
	UIInviteCancelled:false,
	UIInviteInProgress:false,
	UIInviteDialogOpen:false,
    
	UIPoints:0,
	UIPointsPlayer2:0,

	UILives:3,
	UILivesPlayer2:3,
	
	UIFlexYourMuscleCredits:1,	
	UIFlexYourMuscleCreditsPlayer2:1,
	
	UIMoreTimeCredits:2,
	UIMoreTimeCreditsPlayer2:2,
	
	UIWipeOutCredits:1,
	UIWipeOutCreditsPlayer2:1,
	
	UIBadges:[],
	UIBadgesPlayer2:[],
	
	UIFlexYourMuscleToDoublePointsMode:false,
	UISendWipeOutMode:false,
	UIWipedOut:false,
	
	UIWipeOutSound:1,
	UISlyQuestionSound:1,
	UISugarQuestionSound:1,
	
	
	/*
	 * The id of the last question
	 */
	currentQuestionId:null,
	/*
	 * The last answer
	 */
	answer:null,
	/*
	 * boolean answered
	 */
	answered:false,	 
	/*
	 * Time it took to answer the last question in milliseconds
	 */
	answerTime:null,
	clockStarttime:null,
	clockDelay:3000,
	clockTimer:null,
	clockRunning:false,
	clockExtraTime:0,
	questionVisible:false,
	/*
	 * The opponents last answer
	 */
	opponentAnswer:null, 
	/*
	 * boolean opponent answered
	 */
	opponentAnswered:false,
	/*
	 * Time it took the opponent to answer
	 */
	opponentTimeAnswered:null,
	/*
	 * Marks if the opponent tried to sent a wipeout 
	 */
	opponentSendsWipeOut:false,
	/*
	 * Sets the gameObject
	 */
	setGameData:function(obj) {
		console.log('Catch A Wave - Setting gameData');
		console.log(obj);
		catchAWave.gameData=obj;
		if (catchAWave.isTwoPlayerGame() && typeof obj.player2GameData!=='undefined') {
			catchAWave.gameDataPlayer2=obj.player2GameData;
		}
		
	},
	isSinglePlayerGame:function() {
		return (catchAWave.gameData.mode==catchAWave.modeSinglePlayer);
	},
	isSinglePlayerGameOn:function () {
		return (catchAWave.isSinglePlayerGame() && catchAWave.gameData.gameStatus==catchAWave.stateStarted);
	},
	isTwoPlayerGame:function() {
		return ((catchAWave.gameData.mode==catchAWave.modeTwoPlayerPrimary 
				|| catchAWave.gameData.mode==catchAWave.modeTwoPlayerSecondary));
	},
	/*
	 * proxy to setTimeout with the added value that timers are stored in catchAWave.timers
	 */
	setTimeout:function(callback,milliSeconds) {
		// if we are killing timers we can't set a new one
		if (!catchAWave.killingTimers) {
			var timer=setTimeout(callback,milliSeconds);
			catchAWave.timers.push(timer);
			return timer;//
		}
	},
	/*
	 * Kills all running timers before they fire
	 */
	killTimers:function() {
		console.log('Catch A Wave - Kill Timers');
		catchAWave.killingTimers=true;
		for (var i=0;i<catchAWave.timers.length;i++) {
			clearTimeout(catchAWave.timers[i]);
		}
		catchAWave.timers.length=0;
		catchAWave.killingTimers=false;
	},
	/*
	 * Updates the game UI
	 */
	updateUIGameData:function(){
		console.log('Catch A Wave - updateUIGameData');

		catchAWave.updateUIPoints(true);
		catchAWave.updateUILives();
		catchAWave.updateUIFlexYourMuscleCredits();
		catchAWave.updateUIMoreTimeCredits();
		catchAWave.updateUIWipeOutCredits();
		catchAWave.updateUIBadges();

		
		if (catchAWave.isTwoPlayerGame()) {
			$('.gameState').removeClass('gameStateHidden');

			catchAWave.updateUIPointsPlayer2(true);
			catchAWave.updateUILivesPlayer2();
			catchAWave.updateUIFlexYourMuscleCreditsPlayer2();
			catchAWave.updateUIMoreTimeCreditsPlayer2()			
			catchAWave.updateUIWipeOutCreditsPlayer2();
			catchAWave.updateUIBadgesPlayer2();



		}



	},
	/*
	 * Animate the UI points to the gamedata points
	 */
	updateUIPoints:function(isNew) {
		
		if (catchAWave.UIPoints<catchAWave.gameData.points) {
			if (isNew===true) $('.player1 .playerPoints').animateCSS('rubberBand');

			if (catchAWave.gameData.points-catchAWave.UIPoints>100) 			
				catchAWave.UIPoints+=2;
			else 
				catchAWave.UIPoints+=1;

			$('.player1 #pointsValue').html(catchAWave.UIPoints);
			catchAWave.setTimeout(catchAWave.updateUIPoints,1);
		}
		
		if (catchAWave.UIPoints>catchAWave.gameData.points) {
			if (catchAWave.UIPoints-catchAWave.gameData.points>100) 			
				catchAWave.UIPoints-=2;
			else 
				catchAWave.UIPoints-=1;
			$('.player1 #pointsValue').html(catchAWave.UIPoints);
			catchAWave.setTimeout(catchAWave.updateUIPoints,1);
		}


	},
	/*
	 * Animate the UI points to the gamedata points
	 */
	updateUIPointsPlayer2:function(isNew) {
		
		if (catchAWave.UIPointsPlayer2<catchAWave.gameDataPlayer2.points) {
			if (isNew===true) $('.player2 .playerPoints').animateCSS('rubberBand');

			if (catchAWave.gameDataPlayer2.points-catchAWave.UIPointsPlayer2>100) 			
				catchAWave.UIPointsPlayer2+=2;
			else 
				catchAWave.UIPointsPlayer2+=1;

			$('.player2 #pointsValue').html(catchAWave.UIPointsPlayer2);
			catchAWave.setTimeout(catchAWave.updateUIPointsPlayer2,1);
		}
		
		if (catchAWave.UIPointsPlayer2>catchAWave.gameDataPlayer2.points) {
			if (catchAWave.UIPointsPlayer2-catchAWave.gameDataPlayer2.points>100) 			
				catchAWave.UIPointsPlayer2-=2;
			else 
				catchAWave.UIPointsPlayer2-=1;
			$('.player2 #pointsValue').html(catchAWave.UIPointsPlayer2);
			catchAWave.setTimeout(catchAWave.updateUIPointsPlayer2,1);
		}


	},

	updateUILives:function() {
		if (catchAWave.UILives!=catchAWave.gameData.lives) {
			$('.player1 .playerLives').animateCSS('rubberBand');
			catchAWave.UILives=catchAWave.gameData.lives
			$('.player1 #livesValue').html(catchAWave.UILives);
		}
	},
	updateUILivesPlayer2:function() {
		if (catchAWave.UILivesPlayer2!=catchAWave.gameDataPlayer2.lives) {
			$('.player2 .playerLives').animateCSS('rubberBand');
			catchAWave.UILivesPlayer2=catchAWave.gameDataPlayer2.lives
			$('.player2 #livesValue').html(catchAWave.UILivesPlayer2);
		}
	},	
	updateUIFlexYourMuscleCredits:function() {
		
		if (catchAWave.UIFlexYourMuscleCredits!=catchAWave.gameData.flexYourMuscleCredits) {
			$('.player1 .playerFlexYourMuscleCredits').animateCSS('rubberBand');
			catchAWave.UIFlexYourMuscleCredits=catchAWave.gameData.flexYourMuscleCredits;
			$('.player1 #flexYourMuscleCreditsValue').html(catchAWave.UIFlexYourMuscleCredits);
		}
		
	},		
	updateUIFlexYourMuscleCreditsPlayer2:function() {
		
		if (catchAWave.UIFlexYourMuscleCreditsPlayer2!=catchAWave.gameDataPlayer2.flexYourMuscleCredits) {
			$('.player2 .playerFlexYourMuscleCredits').animateCSS('rubberBand');
			catchAWave.UIFlexYourMuscleCreditsPlayer2=catchAWave.gameDataPlayer2.flexYourMuscleCredits;
			$('.player2 #flexYourMuscleCreditsValue').html(catchAWave.UIFlexYourMuscleCreditsPlayer2);
		}
		
	},
	updateUIMoreTimeCredits:function() {
		
		if (catchAWave.UIMoreTimeCredits!=catchAWave.gameData.moreTimeCredits) {
			$('.player1 .playerMoreTimeCredits').animateCSS('rubberBand');
			catchAWave.UIMoreTimeCredits=catchAWave.gameData.moreTimeCredits
			$('.player1 #moreTimeCreditsValue').html(catchAWave.UIMoreTimeCredits);
		}
		
	},
	updateUIMoreTimeCreditsPlayer2:function() {
		
		if (catchAWave.UIMoreTimeCreditsPlayer2!=catchAWave.gameDataPlayer2.moreTimeCredits) {
			$('.player2 .playerMoreTimeCredits').animateCSS('rubberBand');
			catchAWave.UIMoreTimeCreditsPlayer2=catchAWave.gameDataPlayer2.moreTimeCredits
			$('.player2 #moreTimeCreditsValue').html(catchAWave.UIMoreTimeCreditsPlayer2);
		}
		
	},
	updateUIWipeOutCredits:function() {
		
		if (catchAWave.UIWipeOutCredits!=catchAWave.gameData.wipeOutCredits) {
			$('.player1 .playerWipeOutCredits').animateCSS('rubberBand');
			catchAWave.UIWipeOutCredits=catchAWave.gameData.wipeOutCredits
			$('.player1 #wipeOutCreditsValue').html(catchAWave.UIWipeOutCredits);
		}
		
	},
	updateUIWipeOutCreditsPlayer2:function() {
		
		if (catchAWave.UIWipeOutCreditsPlayer2!=catchAWave.gameDataPlayer2.wipeOutCredits) {
			$('.player2 .playerWipeOutCredits').animateCSS('rubberBand');
			catchAWave.UIWipeOutCreditsPlayer2=catchAWave.gameDataPlayer2.wipeOutCredits
			$('.player2 #wipeOutCreditsValue').html(catchAWave.UIWipeOutCreditsPlayer2);
		}
		
	},
	updateUIBadges:function() {
		//console.log('Catch A Wave - Checking Badges');
		var badges=catchAWave.gameData.badges;
		//console.log(badges);
		
		if (catchAWave.gameData.badges==null) return false;
		
		for (var i=0;i<badges.length;i++) {
			//console.log('Catch A Wave checking badge ' + badges[i] );
			if ($.inArray(badges[i],catchAWave.UIBadges)===-1) {
				if ($('#badge-'+badges[i]).css('opacity')<=0) {
					console.log('Catch A Wave - Awarding Badge ' + badges[i]);

					$('#badge-'+badges[i]).appendTo('.player1 .cwBadges');
					$('#badge-'+badges[i]).fadeTo(500,1);
					$('#badge-'+badges[i]).animateCSS('rubberBand');
				}
				catchAWave.UIBadges.push(badges[i]);

			}
		}		
	},
	updateUIBadgesPlayer2:function() {
		//console.log('checking badges');
		var badges=catchAWave.gameDataPlayer2.badges;
		
		if (catchAWave.gameDataPlayer2.badges==null) return false;
		
		//console.log(badges);
		for (var i=0;i<badges.length;i++) {
			//console.log('Catch A Wave checking badge ' + badges[i] );
			if ($.inArray(badges[i],catchAWave.UIBadgesPlayer2)===-1) {
				if ($('#badge-'+badges[i]).css('opacity')<=0) {
					console.log('Catch A Wave - Awarding Badge to Player2' + badges[i]);

					$('.player2 #badge-'+badges[i]).appendTo('.player2 .cwBadges');
					$('.player2 #badge-'+badges[i]).fadeTo(500,1);
					$('.player2 #badge-'+badges[i]).animateCSS('rubberBand');
				}
				catchAWave.UIBadgesPlayer2.push(badges[i]);

			}
		}		
	},
	updateUIPlayer1State:function(options) {
		$('#gameStatePlayer1').html(options.state);
	},
	updateUIPlayer2State:function(options) {
		$('#gameStatePlayer2').html(options.state);
	},
	updateUIMasterPlayerState:function(state) {
		if (catchAWave.connectIsMaster())
			$('#gameStatePlayer1').html(state);
		if (catchAWave.connectIsSlave1())
			$('#gameStatePlayer2').html(state);
	},
	updateUISlave1PlayerState:function(state) {
		if (catchAWave.connectIsMaster())
			$('#gameStatePlayer2').html(state);
		if (catchAWave.connectIsSlave1())
			$('#gameStatePlayer1').html(state);
	},
	/*
	 * Updates the GUI to reflect the latest gameObject
	 */
	updateUIFromObj:function() {},
	playBadgeSound:function(options) {
		var count=0;
		
		if (catchAWave.gameData.badges.length>1) {
			count=catchAWave.gameData.badges.length;
		}
		
		createjs.Sound.play('catchAWave/badge-sound-' + (count+1));
		
		
	},
	playWipeOutSound:function(options) {
		createjs.Sound.play('catchAWave/Wipe-Out-' + catchAWave.UIWipeOutSound,{volume:otuApp.fxOptions.tickingClockVolume});
		catchAWave.UIWipeOutSound++;
		if (catchAWave.UIWipeOutSound>4) catchAWave.UIWipeOutSound=1;
		
	},
	playSlyQuestionSound:function(options) {
		createjs.Sound.play('catchAWave/Sly-' + catchAWave.UISlyQuestionSound),{volume:otuApp.fxOptions.tickingClockVolume};
		catchAWave.UISlyQuestionSound++;
		if (catchAWave.UISlyQuestionSound>6) catchAWave.UISlyQuestionSound=1;
		
	},
	playSugarQuestionSound:function(options) {
		createjs.Sound.play('catchAWave/Sugar-' + catchAWave.UISugarQuestionSound,{volume:otuApp.fxOptions.tickingClockVolume});
		catchAWave.UISugarQuestionSound++;
		if (catchAWave.UISugarQuestionSound>4) catchAWave.UISugarQuestionSound=1;
		
	},	
	/*
	 * We are invited to a catch a wave game
	 */
	refreshGameObject:function(options) {

		var data={};
		
		data.gameId=catchAWave._getGameId();

		// We send the invite and receive the channel back
		var url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=catchawave.refreshGameObject';
		otuApp.triggerAjaxPost(url,data, {
			responseType:'json',
				callback : function(json) {
				if (json.messages!==null) {
					catchAWave._reportMessages(json);
				} 

				if (json.success) {
					//
					console.log('Catch A Wave - Refresh Game Object');
					catchAWave.setGameData(json.data.gameData);
					if (typeof(options || {}).callback==='function') options.callback();
				}
			}
		})
			
	},
	inviteEvent:function() {},
	/*
	 * The opponent answered event
	 */
	opponentAnsweredEvent:function() {},
	/* 
	 * The opponent accepted the invite
	 */
	opponentAcceptedEvent:function() {},
	/*
	 * The opponent rejected the invite
	 */
	opponentRejectedEvent:function() {},
	/*
	 * any error in the catch a wave IO
	 */
	errorEvent:function() {},
	soundTickingClock:null,
	/*
	 * Set Single or Multiplayer mode and return the promise on success
	 */
	setMode:function(data, promise) {
		console.log('Catch A Wave - setMode');
		console.log(data);
		
		var url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=catchawave.setMode';
		
		otuApp.triggerAjaxPost(url,data, {
			responseType:'json',
			debug:false,
			callback : function(json) {
				if (json.messages!==null) {
					catchAWave._reportMessages(json);
				} 
				
				if (json.success) {
					console.log('Catch A Wave - setMode Success');

					// update the gameData;
					catchAWave.setGameData(json.data.gameData);
					// callback the promise
					promise();
				}	
				
			}
			
		})
	},
	/*
	 * Set Time for the questions
	 */
	setTime:function(data) {
		var url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=catchawave.setTime';
		console.log('Catch A Wave - setMode');
		console.log(data);
		
		// add the game ID
		data.gameId=catchAWave.gameData.id;
		
		otuApp.triggerAjaxPost(url,data, {
			responseType:'json',
			callback : function(json) {
				if (json.messages!==null) {
					catchAWave._reportMessages(json);
				} 
				
				if (json.success) {
					console.log('Catch A Wave - setMode Success');

					// update the gameData;
					catchAWave.setGameData(json.data.gameData);					
					
					// if it is a two player game go to the player select
					if (catchAWave.gameData.mode==catchAWave.modeTwoPlayerPrimary) {
						catchAWave.create2PlayerGame();
					} else {
						//otherwise start the game
						catchAWave.startLevel();
					}
				}	
				
			}
			
		})
	},
	/*
	 * Show the create two player game screen
	 */
	create2PlayerGame:function() {
		console.log('Catch A Wave - createTwoPlayerGame');

		catchAWave.resetUIValues();
		
			$('')
			var url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=catchawave.create2PlayerGame';
			var data={};
			
			// add the game ID
			data.gameId=catchAWave._getGameId();

			otuApp.triggerAjaxPost(url,data, {attr:{'data-hide-template-position':'game-1'}});				
		
	},
	/*
	 * Starts the clock
	 */
	startClock:function() {
		console.log('Catch A Wave - startClock');

		// set the initials an start the timer
		catchAWave.startTime=new Date();
		catchAWave.clockRunning=true;
		catchAWave.clockExtraTime=0;
		catchAWave.questionVisible=false;
		$(".catch-a-wave-framework .answers").fadeTo(100,0);

		// make sure the getReady is visible
		$('#getReady').fadeTo(100,1);

		// show the double points button
		if (catchAWave.gameData.flexYourMuscleCredits>0) catchAWave.showFlexYourMuscleToDoublePointsButton();
		
		if (catchAWave.isTwoPlayerGame()) {
			catchAWave.showSendWipeOutButton();
		}
		
		// start the clock	
		catchAWave.clockTimer=catchAWave.setTimeout(catchAWave.updateClock,1);

	},
	/*
	 * updates the clock every millisecond
	 */
	updateClock:function() {
		
		if (!(catchAWave.startTime instanceof Date)) {
			// clock is not running this is an illegal state
			console.log('Catch A Wave - Illegal state, clock not running and starttime is null');
			return false;
		}
		
		var now = new Date();
		
		//  time elapsed since the start
		var elapsed= new Date(now-catchAWave.startTime);
		
		// Time it tpok to answer
		catchAWave.answerTime= new Date(now.getTime()-catchAWave.startTime.getTime()-catchAWave.clockDelay);
		
		
	
		
		// calculate the end time
		var endTime = new Date(catchAWave.startTime.getTime()+catchAWave.clockDelay+(catchAWave.gameData.questionTime*1000)+catchAWave.clockExtraTime);
		
		// the time to display on the clock
		var clockTime=new Date(endTime-now);


		
		// do the pre-countdown and exit if not complete
		if (elapsed.getTime()<catchAWave.clockDelay) {
			var countdown=Math.max(0,(catchAWave.clockDelay/1000)-elapsed.getSeconds());
			$('#clockDelayValue').html(countdown);
			catchAWave.clockTimer=catchAWave.setTimeout(catchAWave.updateClock,1);
			return true;
		}
		
		// If it a two player game check if the opponent send a wipeout
		
		if (catchAWave.isTwoPlayerGame() && catchAWave.opponentSendsWipeOut) {
			catchAWave.opponentSendsWipeOut=false;
			catchAWave.receiveWipeOut();
		}	
		
		// check if we are not autoWipedOut by now
		if (!catchAWave.UIWipedOut 
				&& catchAWave.gameData.autoWipeOutTime>0 
					&& (catchAWave.answerTime.getTime()>catchAWave.gameData.autoWipeOutTime) 
						&& catchAWave.opponentSendsWipeOut===false) {
			catchAWave.wipeOut();	
		}			
		
		// pre count down is complete we can now start the real clock and show the question
		
		if (!catchAWave.questionVisible) {
			catchAWave.questionVisible=true;
			$(".catch-a-wave-framework .answers").fadeTo(500,1,function() {
				$(".catch-a-wave-framework .answers").css('pointer-events','auto');				
			});
			
			// and show the moreTimeButton
			if (catchAWave.gameData.moreTimeCredits>0) catchAWave.showMoreTimeButton();
			// make sure the double points button is hidden if it is not applied
			if (!catchAWave.UIFlexYourMuscleToDoublePointsMode) {
				catchAWave.hideFlexYourMuscleToDoublePointsButton();
			}
			
			// check if we can hide the wipeout button now
			if (catchAWave.isTwoPlayerGame() && !catchAWave.UISendWipeOutMode) {
				catchAWave.hideSendWipeOutButton();
			}
			
			// make sure teh pre count is 0 and hidden
			$('#clockDelayValue').html('0');
			$('#getReady').fadeTo(200,0);//
		}
		
		// start the clock sound and create a new instance if we need to
		if (catchAWave.soundTickingClock===null) {
			catchAWave.soundTickingClock=createjs.Sound.play('ticking-clock',{volume:otuApp.fxOptions.tickingClockVolume});
		} else {
			catchAWave.soundTickingClock.play();
		}
		
		// update the clock if we have not finished
		if (endTime>now) {
			$('#clockValue').html(("0" + clockTime.getSeconds()).slice (-2) + ':' + ("00" + clockTime.getMilliseconds()).slice (-3));
			
			catchAWave.clockTimer=catchAWave.setTimeout(catchAWave.updateClock,1);
		} else {		
			console.log('Catch A Wave - Time is Up');

			$('#clockValue').html("00:000");
			catchAWave.stopClock();
			createjs.Sound.play('answer-wrong',{volume:otuApp.fxOptions.answerSoundVolume});
			var data= {
					answerTimeout:true,
					questionId:$('.question').attr('data-question-id')
			};
			catchAWave.verifyAnswer(data);
		}		
	},
	/*
	 * Stop Clock and set the answer time
	 */
	stopClock:function() {
		console.log('Catch A Wave - stopClock');
		
		catchAWave.disableAnswers();
		clearTimeout(catchAWave.clockTimer);
		catchAWave.hideMoreTimeButton();
		if (catchAWave.soundTickingClock!==null) catchAWave.soundTickingClock.stop();
		catchAWave.clockRunning=false;

		
	},	
	/*
	 * timeSelect - shows the time select screen
	 */
	timeSelect:function() {
		console.log('Catch A Wave - timeSelect');

		var url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=catchawave.timeSelect';
		var data={};
		
		// add the game ID
		data.gameId=catchAWave._getGameId();

		otuApp.triggerAjaxPost(url,data, {attr:{'data-hide-template-position':'game-1'}});		
		
	},
	/*
	 * Checks and Starts a new level 
	 */
	startLevel:function(options) {
		console.log('Catch A Wave - startLevel');

		// Make sure we disable the star new game button now
		
		$('.newGame').attr('data-action-enabled',0);
		
		if (typeof options==='undefined') options={};
		options=$.extend({},{hide:'game-1'},options);
		
		var url = 'index.php?component=com_otu_op&task=catchawave.startLevel';
		var data={};

		// add the game ID
		data.gameId=catchAWave._getGameId();

		otuApp.triggerAjaxPost(url,data, {attr:{'data-hide-template-position':options.hide},callback:function() {}});		
	},
	/*
	 * Check and show the next question 
	 */
	nextQuestion:function() {
		console.log('Catch A Wave - nextQuestion');

		catchAWave.startTime=0;
		
		catchAWave.UIFlexYourMuscleToDoublePointsMode=false;
		catchAWave.UISendWipeOutMode=false;
		catchAWave.UIWipedOut=false;
		
		var url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=catchawave.nextQuestion';
		var data={};
		
		// add the game ID
		data.gameId=catchAWave._getGameId();

		otuApp.triggerAjaxPost(url,data, {
				attr:{'data-hide-template-position':'game-1'}
		});		
	},
	/*
	 * Check and show a flex your muscle question 
	 */
	askFlexYourMuscleQuestion:function() {
		console.log('Catch A Wave - askFlexYourMuscleQuestion');
		
		catchAWave.startTime=0;

		
		// see if we popup a nsgg
		
		// see if we won
		
		var url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=catchawave.askFlexYourMuscleQuestion';
		var data={};
		
		// add the game ID
		data.gameId=catchAWave._getGameId();

		otuApp.triggerAjaxPost(url,data, {attr:{'data-hide-template-position':'game-1'}});		
	},	
	/*
	 * Show the choose how to continue screen
	 */
	chooseHowToContinue: function() {
		console.log('Catch A Wave - chooseHowToContinue');

		catchAWave.startTime=0;
		
		// check if we stil have Lives or Flex your Muscle Credits
		if (catchAWave.gameData.lives>0 || catchAWave.gameData.flexYourMuscleCredits>0) {
		
			
			if (catchAWave.isTwoPlayerGame()) {
				
				if (catchAWave.connectIsSlave1())
					catchAWave.connectEmitGameState( {newStates:['SLAVE1_RECOVERING_FROM_WRONG_ANSWER']});
				
				if (catchAWave.connectIsMaster())
					catchAWave.connectEmitGameState( {newStates:['MASTER_RECOVERING_FROM_WRONG_ANSWER']});

			}
			var url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=catchawave.chooseHowToContinue';
			var data={};
			
			// add the game ID
			data.gameId=catchAWave._getGameId();
	
			otuApp.triggerAjaxPost(url,data, {attr:{'data-hide-template-position':'game-1'}});
			
			return;
		} 
		
		else {
			// we have none left so it is the end
			catchAWave.gameOver();
		}
			
	},
	/*
	 * Use a life to continue
	 */
	useALife:function() {
		console.log('Catch A Wave - useALife');
		
		var url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=catchawave.useALife';
		
		var data={};
		
		//  add the game ID
		data.gameId=catchAWave.gameData.id;
		
		$('.continueActions').fadeOut(500,function() {
			if (catchAWave.isTwoPlayerGame()) {
				$('.waiting4Player2').fadeIn();
			}
		});
		
		otuApp.triggerAjaxPost(url,data, {
			responseType:'json',
			callback : function(json) {
				if (json.messages!==null) {
					catchAWave._reportMessages(json);
				} 
				
				if (json.success) {
					// update the gameData;

					console.log('Catch A Wave - useALife Success');

					if (catchAWave.isSinglePlayerGame()) {			
						catchAWave.setGameData(json.data.gameData);	
						catchAWave.updateUIGameData();
						catchAWave.nextQuestion();
					}
					
					if (catchAWave.isTwoPlayerGame()) {
						
						catchAWave.setGameData(json.data.gameData);	
						catchAWave.updateUIGameData();	
						
						if (catchAWave.connectIsSlave1())
							catchAWave.connectEmitGameState( {newStates:['SLAVE1_USE_A_LIFE','SLAVE1_CONTINUES']});
						
						if (catchAWave.connectIsMaster())
							catchAWave.connectEmitGameState( {newStates:['MASTER_USE_A_LIFE','MASTER_CONTINUES']});

					}
					return;
				}	
				
				// else there is an error and it is game over
				catchAWave.gameOver();
				
			}
			
		})	
		
	},
	/*
	 * Use a flex Your Muscle Credit to try to save your life with a question
	 */
	useAFlexYourMuscleCreditToSaveALife:function() {
		console.log('Catch A Wave - useAFlexYourMuscleCreditToSaveALife');
		
		var url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=catchawave.useAFlexYourMuscleCredit';
		
		var data={};

		$('.continueActions').fadeOut(500,function() {
			if (catchAWave.isTwoPlayerGame()) {
				$('.waiting4Player2').fadeIn();
			}
		});
		
		// add the game ID
		data.gameId=catchAWave.gameData.id;
		
		// add how to apply the credit
		data.type='saveALife';
		
		otuApp.triggerAjaxPost(url,data, {
			responseType:'json',
			callback : function(json) {
				if (json.messages!==null) {
					catchAWave._reportMessages(json);
				} 
				
				if (json.success) {
					// update the gameData;
					console.log('Catch A Wave - useAFlexYourMuscleCreditToSaveALife Success');

					if (catchAWave.isTwoPlayerGame()) {
						
						if (catchAWave.connectIsSlave1())
							catchAWave.connectEmitGameState( {newStates:['SLAVE1_USE_A_FLEX_YOUR_MUSCLE_CREDIT_TO_SAVE_A_LIFE']});
						
						if (catchAWave.connectIsMaster())
							catchAWave.connectEmitGameState( {newStates:['MASTER_USE_A_FLEX_YOUR_MUSCLE_CREDIT_TO_SAVE_A_LIFE']});

					}
					
					
					catchAWave.setGameData(json.data.gameData);	
					catchAWave.updateUIGameData();
					catchAWave.askFlexYourMuscleQuestion();
					return;
					
					
					
				}	
				
				// else there is an error and it is game over
				catchAWave.gameOver();
				
			}
			
		})	
		
	},
	/*
	 * Use a flex Your Muscle Credit to win double points, or loose
	 */
	useAFlexYourMuscleCreditToDoublePoints:function() {
		console.log('Catch A Wave - useAFlexYourMuscleCreditToDoublePoints');

		
		var url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=catchawave.useAFlexYourMuscleCredit';
		
		var data={};
		
		// add the time to the click whatever the server verification result
		if (catchAWave.gameData.flexYourMuscleCredits>0) {			
			$('.flexYourMuscleToDoublePointsAction').addClass('animated blink infinite');
		} else { return }
		
		
		// set the UIFlexYourMuscleToDoublePointsMode to reflect the state
		catchAWave.UIFlexYourMuscleToDoublePointsMode=true;
		
		// add the game ID
		data.gameId=catchAWave.gameData.id;
		
		// add how to apply the credit
		data.type='doublePoints';
		
		otuApp.triggerAjaxPost(url,data, {
			responseType:'json',
			callback : function(json) {
				if (json.messages!==null) {
					catchAWave._reportMessages(json);
				} 
				
				if (json.success) {
					console.log('Catch A Wave - useAFlexYourMuscleCreditToDoublePoints Success');

					// update the gameData;
					catchAWave.setGameData(json.data.gameData);	
					catchAWave.updateUIGameData();
					
					if (catchAWave.isTwoPlayerGame()) {
						
						if (catchAWave.connectIsSlave1())
							catchAWave.connectEmitGameState( {newStates:['SLAVE1_USE_A_FLEX_YOUR_MUSCLE_CREDIT_TO_DOUBLE_POINTS']});
						
						if (catchAWave.connectIsMaster())
							catchAWave.connectEmitGameState( {newStates:['MASTER_USE_A_FLEX_YOUR_MUSCLE_CREDIT_TO_DOUBLE_POINTS']});

					}
					return;
					
				}	
				
				// else there is an error and it is game over
				catchAWave.gameOver();
				
			}
			
		})	
		
	},
	/*
	 * Use a more time credit
	 */
	useAMoreTimeCredit:function() {
		console.log('Catch A Wave - useAMoreTimeCredit');		
		
		var url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=catchawave.useAMoreTimeCredit';
		
		var data={};
		
		catchAWave.hideMoreTimeButton();
		
		// add the time to the click whatever the server verification result
		if (catchAWave.clockRunning && catchAWave.gameData.moreTimeCredits>0) {
			catchAWave.clockExtraTime+=5000;
			
			$('.moreTimeAction').addClass('animated blink infinite');
			
			if (catchAWave.isTwoPlayerGame()) {
				
				if (catchAWave.connectIsSlave1())
					catchAWave.connectEmitGameState( {newStates:['SLAVE1_USE_A_MORE_TIME_CREDIT']});
				
				if (catchAWave.connectIsMaster())
					catchAWave.connectEmitGameState( {newStates:['MASTER_USE_A_MORE_TIME_CREDIT']});

			}
			
		} else { return }
		
		// add the game ID
		data.gameId=catchAWave.gameData.id;
		
		otuApp.triggerAjaxPost(url,data, {
			responseType:'json',
			callback : function(json) {
				if (json.messages!==null) {
					catchAWave._reportMessages(json);
				} 
				
				if (json.success) {
					console.log('Catch A Wave - useAMoreTimeCredit');		

					// update the gameData;
					catchAWave.setGameData(json.data.gameData);	
					catchAWave.updateUIGameData();
					return;
				}	
				
				// else there is an error and it is game over
				catchAWave.gameOver();
			}
			
		})	
	},	
	/*
	 * Show the more time button
	 */
	showMoreTimeButton:function(){
		console.log('Catch A Wave - showMoreTimeButton');		

		$('.moreTimeAction').fadeTo(500,1);
		$('.moreTimeAction').one('click',function() {
				catchAWave.useAMoreTimeCredit();
			})		
	},
	/*
	 * hide the more time button
	 */
	hideMoreTimeButton:function(){
		console.log('Catch A Wave - hideMoreTimeButton');		
		
		$('.moreTimeAction').removeClass('animated blink infinite');
		$('.moreTimeAction').off('click');
		$('.moreTimeAction').fadeTo(500,0.3);
	},
	/*
	 * show the flex your muscle button
	 */
	showFlexYourMuscleToDoublePointsButton : function() {
		console.log('Catch A Wave - showFlexYourMuscleToDoublePointsButton');		

		
		$('.flexYourMuscleToDoublePointsAction').fadeTo(500,1);
		$('.flexYourMuscleToDoublePointsAction').one('click',function() {
				catchAWave.useAFlexYourMuscleCreditToDoublePoints();
			})			
	},	
	/*
	 * hide the flex your muscle button
	 */
	hideFlexYourMuscleToDoublePointsButton:function(){
		console.log('Catch A Wave - hideFlexYourMuscleToDoublePointsButton');		
		
		
		$('.flexYourMuscleToDoublePointsAction').removeClass('animated blink infinite');
		$('.flexYourMuscleToDoublePointsAction').off('click');
		$('.flexYourMuscleToDoublePointsAction').fadeTo(500,0.3);
	},
	/*
	 * show the send wipe out button
	 */
	showSendWipeOutButton : function() {
		console.log('Catch A Wave - showSendWipeOutButton');		

		$('.sendWipeOutAction').fadeTo(500,1);
		$('.sendWipeOutAction').one('click',function() {
				catchAWave.sendWipeOut();
			})			
	},	
	/*
	 * hide the send wipe out button
	 */
	hideSendWipeOutButton:function(){
		console.log('Catch A Wave - hideSendWipeOutButton');		

		$('.sendWipeOutAction').removeClass('animated blink infinite');
		$('.sendWipeOutAction').off('click');
		$('.sendWipeOutAction').fadeTo(500,0.3);
	},
	/*
	 * Disables the answers
	 */
	disableAnswers:function() {
		console.log('Catch A Wave - disableAnswers');		

		$('.answer').off('click');
	},
	/*
	 * Wipe out, you are wiped out, knocks 5 seconds of the clock
	 */
	wipeOut:function(options) {
		console.log('Catch A Wave - wipeOut');		

		
		// add the time to the click whatever the server verification result
		if (catchAWave.clockRunning) {
			console.log('Catch A Wave - Wiping out '+ catchAWave.gameData.autoWipedOutTime) ;
			catchAWave.clockExtraTime-=catchAWave.gameData.autoWipedOutTime;
			//$('.wipeOutNotification').fadeTo(500,1);
			//$('.wipeOutNotification').addClass('animated blink infinite');
			
			$('.game').animateCSS('tada');
			catchAWave.UIWipedOut=true;
			
			
			if (catchAWave.isTwoPlayerGame()) {
				if (catchAWave.connectIsMaster())
					catchAWave.connectEmitGameState( {newStates:['MASTER_WIPEDOUT']});	
				if (catchAWave.connectIsSlave1())
					catchAWave.connectEmitGameState( {newStates:['SLAVE1_WIPEDOUT']});	
			} 
			
			return true;
		} else { 		console.log('Catch A Wave - wipeOut Clock not Running!!!'); return false}		
	},
	/*
	 * Shows the wipeout splash
	 */
	showWipeout:function() {
		console.log('Catch A Wave - showWipeout');		

		catchAWave.playWipeOutSound();

		$('.cw-wipeout-wrap').animateCSS('bounceIn',{
			callback:function() {
				$('.cw-wipeout').animateCSS('rotateOut',{
					callback:function() {
						$('.cw-wipeout-wrap').css('display', 'none');
					}
				});

			}
		});

	},
	sendWipeOut:function() {
		console.log('Catch A Wave - sendWipeout');		
		
		if (catchAWave.isTwoPlayerGame() && catchAWave.gameData.wipeOutCredits>0) {
			catchAWave.UISendWipeOutMode=true;
			$('.sendWipeOutAction').addClass('animated blink infinite');
			if (catchAWave.connectIsSlave1())
				catchAWave.connectEmitGameState( {newStates:['SLAVE1_SENDS_A_WIPEOUT']});
			
			if (catchAWave.connectIsMaster())
				catchAWave.connectEmitGameState( {newStates:['MASTER_SENDS_A_WIPEOUT']});
			
		} else {
			console.log('Catch A Wave - Send wipeout rejected');
		}
		
	},
	receiveWipeOut:function() {
		console.log('Catch A Wave - receiveWipeout');		
		
		if (catchAWave.isTwoPlayerGame()) {
			
			if (catchAWave.wipeOut()) {
				console.log('Catch A Wave - Wipeout accepted')
				// now check if the sender had credits other wise send a gameover
				// you should loose all your points when you give up
				var data={};
				var url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=catchawave.receivedAWipeOut';

				// add the game ID
				data.gameId=catchAWave.gameData.id;
				
				otuApp.triggerAjaxPost(url,data, {
					responseType:'json',
					callback : function(json) {
						if (json.messages!==null) {
							catchAWave._reportMessages(json);
						} 
						
						if (json.success) {
							// update the gameData;
							catchAWave.setGameData(json.data.gameData);	
							console.log('Catch A Wave - Wipout Discounted');

														
							return;
						}	
						
						// else there is an error and it is game over
						catchAWave.gameOver();
					}
				
				});
									
			} else {
				console.log('Catch A Wave - Wipeout rejected')
	
			}
		}
	},
	giveUp: function() {
		console.log('Catch A Wave - Give up');		
		
		// you should loose all your points when you give up
		var data={};
		var url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=catchawave.giveUp';

		// very imporant we kill all running timers
		catchAWave.stopClock();
		catchAWave.killTimers();
		catchAWave.startTime=0;
		
		// add the game ID
		data.gameId=catchAWave.gameData.id;
		
		otuApp.triggerAjaxPost(url,data, {
			responseType:'json',
			callback : function(json) {
				if (json.messages!==null) {
					catchAWave._reportMessages(json);
				} 
				
				if (json.success) {
					console.log('Catch A Wave - Give up Success');		

					// update the gameData;
					catchAWave.setGameData(json.data.gameData);	
					
					if (catchAWave.isTwoPlayerGame()) {
						if (catchAWave.connectIsMaster())
							catchAWave.connectEmitGameState( {newStates:['MASTER_GIVE_UP']});	
						if (catchAWave.connectIsSlave1())
							catchAWave.connectEmitGameState( {newStates:['SLAVE1_GIVE_UP']});	
					} 
					
					if (catchAWave.isSinglePlayerGame()) {
					
						catchAWave.gameOver();
					}					
					
					return;
				}	
				
				// else there is an error and it is game over
				catchAWave.gameOver();
			}
			
		})		
		

	},
	/*
	 * Game Over
	 */
	gameOver: function(options) {
		console.log('Catch A Wave - Game Over');		
		
		// very imporant we kill all running timers
		catchAWave.stopClock();
		catchAWave.killTimers();
		catchAWave.startTime=0;

		
		if (catchAWave.isTwoPlayerGame()) {
				catchAWave.connectEmitGameState( {newStates:['GAME_OVER']});	
		}
		
		if (catchAWave.isSinglePlayerGame()) {
			catchAWave.doGameOver();
		}
			
	},
	doGameOver:function(options) {
		console.log('Catch A Wave - doGameOver');		
		
		// very imporant we kill all running timers
		catchAWave.stopClock();
		catchAWave.killTimers();
		catchAWave.startTime=0;

		
		var url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=catchawave.gameOver';
		var data={};
		
		// add the game ID
		data.gameId=catchAWave._getGameId();

		otuApp.triggerAjaxPost(url,data, {attr:{'data-hide-template-position':'game-1'}});		
	},
	/*
	 * resets the gameData
	 */
	resetGameData:function() {
		console.log('Catch A Wave - resetGameData');		

		if (catchAWave.connectIsGameOn()) {
			if (catchAWave.isTwoPlayerGame()) {
				if (catchAWave.connectIsMaster())
					catchAWave.connectEmitGameState( {newStates:['MASTER_GIVE_UP']});	
				if (catchAWave.connectIsSlave1())
					catchAWave.connectEmitGameState( {newStates:['SLAVE1_GIVE_UP']});	
			}
		}
		
		// we unset the game data so no more messages can be received by us
		catchAWave.gameData={};
		catchAWave.gameDataPlayer2={};

	},
	resetUIValues:function() {
		console.log('Catch A Wave - resetUIValues');		
				
		$('#catchAWaveMessages').empty()

		catchAWave.stopClock();
		// very imporant we kill all running timers
		catchAWave.killTimers();
		catchAWave.startTime=0;
		catchAWave.player2UserId = null;

		catchAWave.UIBadges=[];
		catchAWave.UIFlexYourMuscleCredits=1;
		catchAWave.UIFlexYourMuscleCreditsPlayer2=1;

		catchAWave.UIMoreTimeCredits=2;
		catchAWave.UIMoreTimeCreditsPlayer2=2;

		catchAWave.UIPoints=0;
		catchAWave.UIPointsPlayer2=0;

		catchAWave.UILives=3;
		catchAWave.UILivesPlayer2=3;
		
		catchAWave.UIWipeOutCredits=1;
		catchAWave.UIWipeOutCreditsPlaye2=1;		
		catchAWave.UIBadgesPlayer2=[];
	},
	/*
	 * show HighScores
	 */
	showHighScores: function (options) {
		console.log('Catch A Wave - showHighScores');		
		var url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=catchawave.showHighScores';
		otuApp.triggerAjaxGet(url,options);
	}
	,
	/*
	 * New Game 
	 */
	newGame: function(options) {
		console.log('Catch A Wave - newGame');		
		
		catchAWave.resetUIValues();
		catchAWave.connectInviteRoomId=null;

		var data={};
		var postOptions={};
		
		var url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=catchawave.newGame';

		if (typeof options!=='undefined' && options.new2PlayerGameSlave===true) {
			url= otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=catchawave.new2PlayerGameSlave';
		}
		
		// add the game ID
		data.gameId=catchAWave._getGameId();
		
		// we empty the game data
		if (typeof options!=='undefined' && options.new2PlayerGameSlave!==true) {
			catchAWave.gameData={};
		}	

		if (typeof options!=='undefined' && typeof options.postOptions!== 'undefined') postOptions=options.postOptions;
		
		postOptions.debug=false;
		
		postOptions.attr={'data-hide-template-position':'columns-all'};

		otuApp.triggerAjaxPost(url,data,postOptions);
			
	},
	/*
	 * Advanced game. shows the unlock advanced game..
	 */
	advancedGame:function() {
		console.log('Catch A Wave - advancedGame');		

		var getOptions={};
		
		var url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=goToStep&step=685';
		
		otuApp.triggerAjaxGet(url,getOptions);
		
	},
	/*
	 * Invite player to a two player game.
	 */
	invitePlayer:function(options) {
		console.log('Catch A Wave - invitePlayer');		

		var url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=catchawave.invitePlayer';
		var data={};
		
		data.userId=options.userId;

		catchAWave.player2UserId = options.userId;
				
		// add the game ID
		data.gameId=catchAWave._getGameId();

		otuApp.triggerAjaxPost(url,data);
	},		
	/*
	 * Invite player to a two player game.
	 */
	loadPlayer2:function(options) {
		console.log('Catch A Wave - loadPlayer2');		

		var url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=catchawave.loadPlayer2';
		var data={};
		
		$('.player2').removeClass('player2Hidden');

		
		
		// add the game ID
		data.gameId=catchAWave._getGameId();
		otuApp.triggerAjaxPost(url,data,{
			callback:function() {
				// making the game state visibleç
				console.log('Catch A Wave - loadPlayer2 Success');		


			},
			attr:{'data-hide-template-position':'player-2'}
			
		});
	},
	/*
	 * show the a flex your muscle credit has been awarded screen
	 */
	showAwardedAFlexYourMuscleCredit:function(options) {
		console.log('Catch A Wave - showAwardedAFlexYourMuscleCredit');		

		
		var url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&indexPage=1&task=goToStep&step=687';
		var data={};
			
		// add the game ID
		otuApp.triggerAjaxGet(url,{
			callback:function() {
				// 
				console.log('Catch A Wave - showAwardedAFlexYourMuscleCredit Success');		

			},
			attr:{'data-hide-template-position':'game-1'}
			
		});
	},
	/*
	 * show the we have opened the chest screen
	 */
	showAwardedOpenChest:function(options) {
		console.log('Catch A Wave - showAwardedOpenChest');		

		var url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&indexPage=1&task=goToStep&step=735';
		var data={};
			
		// add the game ID
		otuApp.triggerAjaxGet(url,{
			callback:function() {
				// 
				console.log('Catch A Wave - showAwardedOpenChest Success');		

			},
			attr:{'data-hide-template-position':'game-1'}
			
		});
	},
	/*
	 * test award badge
	 */
	testAwardBadge:function(options) {
		console.log('Catch A Wave - testAwardBadge');		

		var url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&indexPage=1&task=goToStep&step=686';
		var data={};
			
		// add the game ID
		otuApp.triggerAjaxGet(url,{
			callback:function() {
				// 
				console.log('Catch A Wave - testAwardBadge Success');		

			},
			attr:{'data-hide-template-position':'game-1'}
			
		});
	},
	connectIsGameOn:function() {
		//console.log('Catch A Wave - connectIsGameOn');		

			return (catchAWave.isTwoPlayerGame() 
					&& $.inArray('GAME_OVER',catchAWave.connectGameState)==-1
						&& $.inArray('MASTER_CHOOSE_PLAYER_2',catchAWave.connectGameState)==-1);
	},
	isVisible:function() {
		return $('.catch-a-wave-framework').length>0;
	},
	/*
	 * Makes the game  reflect the connectgamestate
	 */
	connectUpdateUIGameState:function($options) {
		//console.log('Catch A Wave - connectUpdateUIGameState');		

		var _exists=catchAWave._exists;
		var _remove=catchAWave._remove;
		var _clearQuestionState=catchAWave._clearQuestionState;
		
		catchAWave.connectGameState.forEach(function(state,array){
				switch (state) {
					case 'SLAVE1_INVITE_RECEIVED':
						if (catchAWave.connectIsMaster()) {
							catchAWave.connectToPlayerSetState({state:'Invite was received, waiting for response'});
						}
						break;
					case 'SLAVE1_INVITE_ACCEPTED':
						if (catchAWave.connectIsMaster())
							catchAWave.connectToPlayerSetState({state:'Invite was accepted'});
						break;
					case 'SLAVE1_INVITE_DECLINED_NOT_JOURNALLED':
						if (catchAWave.connectIsMaster()) {
							catchAWave.connectToPlayerSetState({state:'This user has to make a journal entry first to be able to play Catch A Wave! Send a message on Tone-Up Talk to remind this user to Journal every day!'});
							$('.cwCancelInvite').css('display','none');
							$('.cwChat').css('display','block');

						}
						break;
					case 'SLAVE1_INVITE_DECLINED_TO_BUSY':
						if (catchAWave.connectIsMaster()) {
							catchAWave.connectToPlayerSetState({state:'This user is on a page that does not allow for Catch A Wave invites to show, please try again in a minute or send a message first on Tone-Up talk!'});
							$('.cwCancelInvite').css('display','none');
							$('.cwChat').css('display','block');
						}	
						break;
					case 'SLAVE1_INVITE_DECLINED_ALREADY_PLAYING':
						if (catchAWave.connectIsMaster()) {
							catchAWave.connectToPlayerSetState({state:'I am already playing a game!'});
							$('.cwCancelInvite').css('display','none');
							$('.cwChat').css('display','block');
						}	
						break;
					case 'SLAVE1_INVITE_DECLINED':
						if (catchAWave.connectIsMaster()) {
							catchAWave.connectToPlayerSetState({state:'I am too busy right now, try again later!'});
							$('.cwCancelInvite').css('display','none');
							$('.cwChat').css('display','block');
						}
						break;
					case 'MASTER_STARTLEVEL_WAITING':
						catchAWave.updateUIMasterPlayerState('Get Ready')
						break;
					case 'SLAVE1_STARTLEVEL_WAITING':
						catchAWave.updateUISlave1PlayerState('Get Ready')
						break;		
					case 'MASTER_STARTLEVEL_READY':
						catchAWave.updateUIMasterPlayerState('Ready')
						break;
					case 'SLAVE1_STARTLEVEL_READY':
						catchAWave.updateUISlave1PlayerState('Ready')
						break;	
					case 'MASTER_QUESTION_ANSWERING':
						catchAWave.updateUIMasterPlayerState('Answering Question')
						break;
					case 'SLAVE1_QUESTION_ANSWERING':
						catchAWave.updateUISlave1PlayerState('Answering Question')
						break;
					case 'MASTER_QUESTION_ANSWERED_RIGHT':
						if (_exists('MASTER_USE_A_FLEX_YOUR_MUSCLE_CREDIT_TO_DOUBLE_POINTS')) {
							catchAWave.updateUIMasterPlayerState('Won Double Points!');							
						} else {
							catchAWave.updateUIMasterPlayerState('Answered Right!');
						}
						break;
					case 'MASTER_QUESTION_ANSWERED_WRONG':
						if (_exists('MASTER_USE_A_FLEX_YOUR_MUSCLE_CREDIT_TO_DOUBLE_POINTS')) {
							catchAWave.updateUIMasterPlayerState('Lost Double Points!')
							
						} else {
							catchAWave.updateUIMasterPlayerState('Answered Wrong!')
						}	
						break;
					case 'MASTER_QUESTION_ANSWERED_TOO_LATE':
						if (_exists('MASTER_USE_A_FLEX_YOUR_MUSCLE_CREDIT_TO_DOUBLE_POINTS')) {
							catchAWave.updateUIMasterPlayerState('Lost Double Points!')
							
						} else {
							catchAWave.updateUIMasterPlayerState('Too Late!')	
						}	
						break;
					case 'SLAVE1_QUESTION_ANSWERED_RIGHT':
						if (_exists('SLAVE1_USE_A_FLEX_YOUR_MUSCLE_CREDIT_TO_DOUBLE_POINTS')) {
							catchAWave.updateUISlave1PlayerState('Won Double Points!');							
						} else {
							catchAWave.updateUISlave1PlayerState('Answered Right!')
						}
						break;
					case 'SLAVE1_QUESTION_ANSWERED_WRONG':
						if (_exists('SLAVE1_USE_A_FLEX_YOUR_MUSCLE_CREDIT_TO_DOUBLE_POINTS')) {
							catchAWave.updateUISlave1PlayerState('Lost Double Points!')
							
						} else {
							catchAWave.updateUISlave1PlayerState('Answered Wrong!')
						}
						break;
					case 'SLAVE1_QUESTION_ANSWERED_TOO_LATE':
						if (_exists('SLAVE1_USE_A_FLEX_YOUR_MUSCLE_CREDIT_TO_DOUBLE_POINTS')) {
							catchAWave.updateUISlave1PlayerState('Lost Double Points!');
							
						} else {
							catchAWave.updateUISlave1PlayerState('Too Late!');
						}						
						break;
					case 'MASTER_RECOVERING_FROM_WRONG_ANSWER':	
						catchAWave.updateUIMasterPlayerState('Choosing how to Continue')	
						break;
					case 'SLAVE1_RECOVERING_FROM_WRONG_ANSWER':	
						catchAWave.updateUISlave1PlayerState('Choosing how to Continue')	
						break;
					case 'MASTER_USE_A_LIFE':
						catchAWave.updateUIMasterPlayerState('Lost a Life!');
						break;
					case 'SLAVE1_USE_A_LIFE':
						catchAWave.updateUISlave1PlayerState('Lost a Life!');
						break;
					case 'MASTER_USE_A_FLEX_YOUR_MUSCLE_CREDIT_TO_SAVE_A_LIFE':
						catchAWave.updateUIMasterPlayerState('Flexing a Muscle!');
						break;
					case 'SLAVE1_USE_A_FLEX_YOUR_MUSCLE_CREDIT_TO_SAVE_A_LIFE':
						catchAWave.updateUIMasterPlayerState('Flexing A Muscle!');
						break;
					case 'MASTER_FLEX_QUESTION_ANSWERED_RIGHT':
						catchAWave.updateUIMasterPlayerState('Saved a Life!');
						break;
					case 'SLAVE1_FLEX_QUESTION_ANSWERED_RIGHT':
						catchAWave.updateUISlave1PlayerState('Saved a Life!');
						break;
					case 'MASTER_FLEX_QUESTION_ANSWERED_WRONG':
						catchAWave.updateUIMasterPlayerState('Oh no.. Wrong Again!');
						break;	
					case 'SLAVE1_FLEX_QUESTION_ANSWERED_WRONG':
						catchAWave.updateUISlave1PlayerState('Oh no.. Wrong Again!');
						break;
					case 'MASTER_FLEX_QUESTION_ANSWERED_TOO_LATE':
						catchAWave.updateUIMasterPlayerState('Oh no.. Too Late!');
						break;
					case 'SLAVE1_FLEX_QUESTION_ANSWERED_TOO_LATE':
						catchAWave.updateUISlave1PlayerState('Oh no.. Too Late!');
						break;
					case 'MASTER_GIVE_UP':
						catchAWave.updateUIMasterPlayerState('I Give Up!');
						break;
					case 'SLAVE1_GIVE_UP':
						catchAWave.updateUISlave1PlayerState('I Give Up!');
						break;
					case 'GAME_OVER':
						// we should add the win or loose state here
						if (!_exists('MASTER_GIVE_UP')) catchAWave.updateUIMasterPlayerState('Game Over!');
						if (!_exists('SLAVE1_GIVE_UP')) catchAWave.updateUISlave1PlayerState('Game Over!');
						break;
						
					case 'MASTER_USE_A_FLEX_YOUR_MUSCLE_CREDIT_TO_DOUBLE_POINTS':
						catchAWave.updateUIMasterPlayerState('Flexing a Muscle!');
						break;
					case 'SLAVE1_USE_A_FLEX_YOUR_MUSCLE_CREDIT_TO_DOUBLE_POINTS':
						catchAWave.updateUISlave1PlayerState('Flexing a Muscle!');
						break;	
					case 'MASTER_USE_A_MORE_TIME_CREDIT':
						catchAWave.updateUIMasterPlayerState('I Need More Time!');
						break;
					case 'SLAVE1_USE_A_MORE_TIME_CREDIT':
						catchAWave.updateUISlave1PlayerState('I Need More Time!');
						break;		
					case 'MASTER_SENDS_A_WIPEOUT':
						catchAWave.updateUISlave1PlayerState('Sending Wipeout!');
					break;						
					case 'SLAVE1_SENDS_A_WIPEOUT':
							catchAWave.updateUISlave1PlayerState('Sending Wipeout!');
						break;
					case 'MASTER_WIPEDOUT':
						catchAWave.updateUISlave1PlayerState('Wipeout!');
					break;						
					case 'SLAVE1_WIPEDOUT':
							catchAWave.updateUISlave1PlayerState('Wipeout!');
						break;


						
						

						
						
	
						
				
				}
			
		});
		
	},
	/*
	 * Connect updateGameState ...
	 */
	connectUpdateGameState:function(options) {
		console.log('Catch A Wave - connectUpdateGameState');		
		//console.log(catchAWave.connectGameState);
		
		var _exists=catchAWave._exists;
		var _remove=catchAWave._remove;
		var _clearQuestionState=catchAWave._clearQuestionState;		
	
		var newStates=options.newStates;
		var newState=[];
		var splice=-1;
		var updateUIGameState=true;
		 
		// check if it was an invite retraction
		// the master can give up inviting too so here the slave closes the invite if that happens
		if ((catchAWave.UIInviteInProgress || catchAWave.UIInviteDialogOpen) 
				&& catchAWave.connectInviteRoomId==options.roomId 
					&& (($.inArray('MASTER_CANCELLED_INVITE',newStates)!==-1)
						|| ($.inArray('MASTER_GIVE_UP',newStates)!==-1))) {

				if (catchAWave.UIInviteInProgress) {
					catchAWave.UIInviteCancelled=true;
					//catchAWave.resetGameData();
					console.log('Catch A Wave Game - Invite was cancelled by the master before dialog was shown')
					catchAWave.UIInviteInProgress=false;
				}
				
				if (catchAWave.UIInviteDialogOpen) {
					// we are in a different browser that where we accepted the invite
					console.log('Catch A Wave Game - Invite was retracted by the master')
					$('#modalCatchAWavenInvite').modal('hide');
					catchAWave.UIInviteDialogOpen=false;
					//catchAWave.resetGameData();
				}
				
				return false;
		
		}
		
		// first check if this message was really for us
		if (options.ignoreRoom!==true && !catchAWave.connectIsRoom(options.roomId) ) {
			console.log('Catch A Wave - Message is not for us but for room ' + options.roomId);
			return false;
		}
		
		//console.log('Catch A Wave - updating game state with new states');
		//console.log(newStates);
		for (var i = 0; i < newStates.length; i++) {
			newState=newStates[i];
						
			// we set the new state if not already set
			if ($.inArray(newState,catchAWave.connectGameState)===-1) {
				switch (newState) {
					case 'MASTER_CHOOSE_PLAYER_2':
						catchAWave.connectGameState=[];
						catchAWave.connectGameState.push(newState);						
						break;
					case 'MASTER_CONNECTING_TO_PLAYER_2':
						catchAWave._remove('MASTER_CHOOSE_PLAYER_2');
						catchAWave._remove('SLAVE1_INVITE_DECLINED_ALREADY_PLAYING');
						catchAWave._remove('SLAVE1_INVITE_DECLINED_TO_BUSY');	
						catchAWave._remove('SLAVE1_INVITE_DECLINED_NOT_JOURNALLED');						
						catchAWave.connectGameState.push(newState);						
						break;						
					case 'SLAVE1_INVITE_RECEIVED':
						catchAWave.connectGameState=[];
						catchAWave.connectGameState.push(newState);
						break;
					case 'SLAVE1_INVITE_ACCEPTED':
						catchAWave.connectGameState=[];
						catchAWave.connectGameState.push(newState);
						// on the master we can accept the invite
						if (catchAWave.connectIsMaster()) {
							catchAWave.loadPlayer2();
							catchAWave.startLevel();		
						}	
						
						if (catchAWave.UIInviteDialogOpen) {
							// we are in a different browser that where we accepted the invite
							console.log('Catch A Wave Game - Invite was accepted in a different browser')
							$('#modalCatchAWavenInvite').modal('hide');
							catchAWave.UIInviteDialogOpen=false;
							break;
						}
						
						if (catchAWave.connectIsSlave1()) {		
							otuApp.fxQ.queue(function(next) {
								catchAWave.startLevel();										
								next();
							})
						}
							
						
						
						
						break;
					case 'SLAVE1_INVITE_DECLINED_NOT_JOURNALLED':
					case 'SLAVE1_INVITE_DECLINED_TO_BUSY':												
					case 'SLAVE1_INVITE_DECLINED_ALREADY_PLAYING':						
					case 'SLAVE1_INVITE_DECLINED':
						catchAWave.connectGameState=[];
						catchAWave.connectGameState.push(newState);
						if (catchAWave.connectIsMaster()) {
							catchAWave.setTimeout(function(){
								catchAWave.create2PlayerGame();								
							}, 8000);
						}
						
						if (catchAWave.UIInviteDialogOpen) {
							// we are in a different browser that where we declined the invite
							console.log('Catch A Wave Game - Invite was accepted in a different browser')
							$('#modalCatchAWavenInvite').modal('hide');
							catchAWave.UIInviteDialogOpen=false;
							break;
						}	
						break;
					case 'MASTER_STARTLEVEL_WAITING':
						if (!_exists('MASTER_STARTLEVEL_READY')) catchAWave.connectGameState.push(newState);
						break;
					case 'SLAVE1_STARTLEVEL_WAITING':
						_remove('SLAVE1_INVITE_ACCEPTED');
						if (!_exists('SLAVE1_STARTLEVEL_READY')) catchAWave.connectGameState.push(newState);
						break;
					case 'MASTER_STARTLEVEL_READY':
						_remove('MASTER_STARTLEVEL_WAITING')
						catchAWave.connectGameState.push(newState);
						// if we are both ready we can show the question
						if (_exists('SLAVE1_STARTLEVEL_READY')) catchAWave.nextQuestion();
						break;
					case 'SLAVE1_STARTLEVEL_READY':
						_remove('SLAVE1_STARTLEVEL_WAITING')
						catchAWave.connectGameState.push(newState);
						// if we are both ready we can show the question
						if (_exists('MASTER_STARTLEVEL_READY')) catchAWave.nextQuestion();
						break;
					case 'MASTER_QUESTION_ANSWERING':
						//_clearQuestionState();	
						catchAWave.connectGameState.push(newState);
						break;
					case 'SLAVE1_QUESTION_ANSWERING':
						//_clearQuestionState();
						catchAWave.connectGameState.push(newState);
						break;
					case 'MASTER_QUESTION_ANSWERED_RIGHT':
						_remove('MASTER_QUESTION_ANSWERING');
						catchAWave.connectGameState.push(newState);
						// if we both answered right we can go to the next question
						
						if (_exists('SLAVE1_QUESTION_ANSWERED_RIGHT') || _exists('SLAVE1_CONTINUES')) {
							updateUIGameState=false;
							catchAWave.connectUpdateUIGameState();
							_clearQuestionState();								
							// refresh the scores
							catchAWave.refreshGameObject({
								callback:function() {								
									catchAWave.updateUIGameData();
									catchAWave.setTimeout(function(){
										if (catchAWave.UIChestOpenAwardedFlag) {
											catchAWave.UIChestOpenAwardedFlag=false;
											catchAWave.showAwardedOpenChest();
										} else if (catchAWave.UIflexYourMuscleCreditAwardedFlag) {
											catchAWave.UIflexYourMuscleCreditAwardedFlag=false;
											catchAWave.showAwardedAFlexYourMuscleCredit();
										} else {
											catchAWave.nextQuestion();
										}	
									},5000);										
								}
							});						}
						break;
					case 'SLAVE1_QUESTION_ANSWERED_RIGHT':
						_remove('SLAVE1_QUESTION_ANSWERING');
						catchAWave.connectGameState.push(newState);
						// if we both answered right we can go to the next question
						if (_exists('MASTER_QUESTION_ANSWERED_RIGHT') || _exists('MASTER_CONTINUES')) {
							updateUIGameState=false;
							catchAWave.connectUpdateUIGameState();
							_clearQuestionState();								
							// refresh the scores
							catchAWave.refreshGameObject({
								callback:function() {								
									catchAWave.updateUIGameData();
									catchAWave.setTimeout(function(){
										if (catchAWave.UIChestOpenAwardedFlag) {
											catchAWave.UIChestOpenAwardedFlag=false;
											catchAWave.showAwardedOpenChest();
										} else if (catchAWave.UIflexYourMuscleCreditAwardedFlag) {
											catchAWave.UIflexYourMuscleCreditAwardedFlag=false;
											catchAWave.showAwardedAFlexYourMuscleCredit();
										} else {
											catchAWave.nextQuestion();
										}	
									},5000);										
								}
							});
					}
						break;
					case 'MASTER_QUESTION_ANSWERED_WRONG':
						_remove('MASTER_QUESTION_ANSWERING');
						catchAWave.connectGameState.push(newState);
						break;
					case 'MASTER_QUESTION_ANSWERED_TOO_LATE':
						_remove('MASTER_QUESTION_ANSWERING');
						catchAWave.connectGameState.push(newState);
						break;
					case 'MASTER_RECOVERING_FROM_WRONG_ANSWER':	
						_remove('MASTER_FLEX_QUESTION_ANSWERED_RIGHT');
						_remove('MASTER_FLEX_QUESTION_ANSWERED_WRONG');
						_remove('MASTER_FLEX_QUESTION_ANSWERED_TOO_LATE');
						_remove('MASTER_USE_A_FLEX_YOUR_MUSCLE_CREDIT_TO_SAVE_A_LIFE');
						_remove('MASTER_USE_A_MORE_TIME_CREDIT');

						catchAWave.connectGameState.push(newState);
						break;	

					case 'SLAVE1_QUESTION_ANSWERED_WRONG':
						_remove('SLAVE1_QUESTION_ANSWERING');
						catchAWave.connectGameState.push(newState);
						break;
					case 'SLAVE1_QUESTION_ANSWERED_TOO_LATE':
						_remove('SLAVE1_QUESTION_ANSWERING');
						catchAWave.connectGameState.push(newState);
						break;
					case 'SLAVE1_RECOVERING_FROM_WRONG_ANSWER':	
						_remove('SLAVE1_FLEX_QUESTION_ANSWERED_RIGHT');
						_remove('SLAVE1_FLEX_QUESTION_ANSWERED_WRONG');
						_remove('SLAVE1_FLEX_QUESTION_ANSWERED_TOO_LATE');
						_remove('SLAVE1_USE_A_FLEX_YOUR_MUSCLE_CREDIT_TO_SAVE_A_LIFE')
						_remove('SLAVE1_USE_A_MORE_TIME_CREDIT');

						catchAWave.connectGameState.push(newState);

						break;						
						
					case 'MASTER_CONTINUES':
						// we have choosen how to continue after we answered wrong
						_remove('MASTER_QUESTION_ANSWERED_WRONG');
						_remove('MASTER_QUESTION_ANSWERED_TOO_LATE');

						catchAWave.connectGameState.push(newState);
						// if the opponent either  answered right or is able to continue we can go to the next question
						if (_exists('SLAVE1_QUESTION_ANSWERED_RIGHT') || _exists('SLAVE1_CONTINUES') ) {
							updateUIGameState=false;
							catchAWave.connectUpdateUIGameState();
							_clearQuestionState();								
							// refresh the scores
							catchAWave.refreshGameObject({
								callback:function() {								
									catchAWave.updateUIGameData();
									catchAWave.setTimeout(function(){
										if (catchAWave.UIChestOpenAwardedFlag) {
											catchAWave.UIChestOpenAwardedFlag=false;
											catchAWave.showAwardedOpenChest();
										} else if (catchAWave.UIflexYourMuscleCreditAwardedFlag) {
											catchAWave.UIflexYourMuscleCreditAwardedFlag=false;
											catchAWave.showAwardedAFlexYourMuscleCredit();
										} else {
											catchAWave.nextQuestion();
										}	
									},2000);										
								}
							});
						}	
						break;
					case 'SLAVE1_CONTINUES':
						// we have choosen how to continue after we answered wrong
						_remove('SLAVE1_QUESTION_ANSWERED_WRONG');
						_remove('SLAVE1_QUESTION_ANSWERED_TOO_LATE');

						catchAWave.connectGameState.push(newState);
						// if the opponent either answered right or is able to continue we can go to the next question
						if (_exists('MASTER_QUESTION_ANSWERED_RIGHT') || _exists('MASTER_CONTINUES') ) {
							updateUIGameState=false;
							catchAWave.connectUpdateUIGameState();
							_clearQuestionState();								
							// refresh the scores
							catchAWave.refreshGameObject({
								callback:function() {								
									catchAWave.updateUIGameData();
									catchAWave.setTimeout(function(){
										if (catchAWave.UIChestOpenAwardedFlag) {
											catchAWave.UIChestOpenAwardedFlag=false;
											catchAWave.showAwardedOpenChest();
										} else if (catchAWave.UIflexYourMuscleCreditAwardedFlag) {
											catchAWave.UIflexYourMuscleCreditAwardedFlag=false;
											catchAWave.showAwardedAFlexYourMuscleCredit();
										} else {
											catchAWave.nextQuestion();
										}	
									},2000);										
								}
							});
						}	
						break;
					case 'MASTER_USE_A_LIFE':
						catchAWave.connectGameState.push(newState);						
						break;
					case 'SLAVE1_USE_A_LIFE':
						catchAWave.connectGameState.push(newState);						
						break;
					case 'MASTER_USE_A_FLEX_YOUR_MUSCLE_CREDIT_TO_SAVE_A_LIFE':
						catchAWave.connectGameState.push(newState);						
						break;
					case 'SLAVE1_USE_A_FLEX_YOUR_MUSCLE_CREDIT_TO_SAVE_A_LIFE':
						catchAWave.connectGameState.push(newState);						
						break;
					case 'MASTER_FLEX_QUESTION_ANSWERED_RIGHT':
						catchAWave.connectGameState.push(newState);						
						break;
					case 'SLAVE1_FLEX_QUESTION_ANSWERED_RIGHT':
						catchAWave.connectGameState.push(newState);						
						break;
					case 'MASTER_FLEX_QUESTION_ANSWERED_WRONG':
						catchAWave.connectGameState.push(newState);						
						break;
					case 'SLAVE1_FLEX_QUESTION_ANSWERED_WRONG':
						catchAWave.connectGameState.push(newState);						
						break;
					case 'MASTER_FLEX_QUESTION_ANSWERED_TOO_LATE':
						catchAWave.connectGameState.push(newState);						
						break;
					case 'SLAVE1_FLEX_QUESTION_ANSWERED_TOO_LATE':
						catchAWave.connectGameState.push(newState);						
						break;		
					case 'MASTER_GIVE_UP':						
						catchAWave.connectGameState.push(newState);
						catchAWave.connectEmitGameState( {newStates:['GAME_OVER']});	
						break;	
					case 'SLAVE1_GIVE_UP':
						catchAWave.connectGameState.push(newState);
						catchAWave.connectEmitGameState( {newStates:['GAME_OVER']});	
						break;
					case 'GAME_OVER':
						if (!_exists('GAME_OVER')) catchAWave.doGameOver();	
						catchAWave.connectGameState.push(newState);
						break;
					case 'MASTER_USE_A_FLEX_YOUR_MUSCLE_CREDIT_TO_DOUBLE_POINTS':
						catchAWave.connectGameState.push(newState);
						break;
					case 'SLAVE1_USE_A_FLEX_YOUR_MUSCLE_CREDIT_TO_DOUBLE_POINTS':
						catchAWave.connectGameState.push(newState);
						break;		
					case 'MASTER_USE_A_MORE_TIME_CREDIT':
						catchAWave.connectGameState.push(newState);
						break;
					case 'SLAVE1_USE_A_MORE_TIME_CREDIT':
						catchAWave.connectGameState.push(newState);
						break;
					case 'MASTER_SENDS_A_WIPEOUT':
						catchAWave.connectGameState.push(newState);
						if (catchAWave.connectIsSlave1()) catchAWave.opponentSendsWipeOut=true;
						break;
					case 'SLAVE1_SENDS_A_WIPEOUT':
						catchAWave.connectGameState.push(newState);
						if (catchAWave.connectIsMaster()) catchAWave.opponentSendsWipeOut=true;
						break;
					case 'MASTER_WIPEDOUT':
						catchAWave.connectGameState.push(newState);						
						break;
					case 'SLAVE1_WIPEDOUT':
						catchAWave.connectGameState.push(newState);						
						break;
						




						
	
				
				}
			}
			
		}
		
		//console.log('Catch A Wave - New Game State');
		console.log(catchAWave.connectGameState);
		if (updateUIGameState) catchAWave.connectUpdateUIGameState();

	},
	_remove: function (ele) {
		var splice=$.inArray(ele,catchAWave.connectGameState);
		if (splice!=-1) {
			console.log('Catch A Wave Removing State ' + ele);
			catchAWave.connectGameState.splice(splice,1);			
		}
	},
	_exists:function(ele) {
		return ($.inArray(ele,catchAWave.connectGameState)!==-1);
	},
	_clearQuestionState: function () {
		console.log('Catch A Wave - Clearing Question States');
		var _exists=catchAWave._exists;
		var _remove=catchAWave._remove;
		
		if (catchAWave.isTwoPlayerGame()) catchAWave.oppenentSendsWipeOut=false;
		
		_remove('MASTER_STARTLEVEL_READY');
		_remove('MASTER_STARTLEVEL_WAITING');
		
		_remove('MASTER_QUESTION_ANSWERED_RIGHT');
		_remove('MASTER_QUESTION_ANSWERED_WRONG');
		_remove('MASTER_QUESTION_ANSWERED_TOO_LATE');						
		
		_remove('MASTER_CONTINUES');
		_remove('MASTER_USE_A_LIFE');
		
		_remove('MASTER_FLEX_QUESTION_ANSWERED_RIGHT');
		_remove('MASTER_FLEX_QUESTION_ANSWERED_WRONG');
		_remove('MASTER_FLEX_QUESTION_ANSWERED_TOO_LATE');
		_remove('MASTER_RECOVERING_FROM_WRONG_ANSWER');

		_remove('MASTER_USE_A_FLEX_YOUR_MUSCLE_CREDIT_TO_DOUBLE_POINTS')
		
		_remove('MASTER_USE_A_FLEX_YOUR_MUSCLE_CREDIT_TO_SAVE_A_LIFE')

		_remove('MASTER_USE_A_MORE_TIME_CREDIT');
		
		_remove('MASTER_SENDS_A_WIPEOUT');
		
		_remove('MASTER_WIPEDOUT');
		
		_remove('SLAVE1_STARTLEVEL_READY');
		_remove('SLAVE1_STARTLEVEL_WAITING');
		
		_remove('SLAVE1_QUESTION_ANSWERED_RIGHT');
		_remove('SLAVE1_QUESTION_ANSWERED_WRONG');
		_remove('SLAVE1_QUESTION_ANSWERED_TOO_LATE');						
		
		_remove('SLAVE1_CONTINUES');
		_remove('SLAVE1_USE_A_LIFE');		
		
		_remove('SLAVE1_FLEX_QUESTION_ANSWERED_RIGHT');
		_remove('SLAVE1_FLEX_QUESTION_ANSWERED_WRONG');
		_remove('SLAVE1_FLEX_QUESTION_ANSWERED_TOO_LATE');

		_remove('SLAVE1_RECOVERING_FROM_WRONG_ANSWER');
		
		_remove('SLAVE1_USE_A_FLEX_YOUR_MUSCLE_CREDIT_TO_DOUBLE_POINTS')
		
		_remove('SLAVE1_USE_A_FLEX_YOUR_MUSCLE_CREDIT_TO_SAVE_A_LIFE');
		
		_remove('SLAVE1_USE_A_MORE_TIME_CREDIT');
		
		_remove('SLAVE1_SENDS_A_WIPEOUT');
		
		_remove('SLAVE1_WIPEDOUT');			
	},	
	connectEmitGameState:function(newStates, f_options) {
		console.log('Catch A Wave - connectEmitGameState');

		var options = {p2p:true, roomId:catchAWave.gameData.roomId};
		$.extend(options,f_options );
		try {
			socketIo.emitMessageToRoom({roomId:options.roomId,event:'catchAWaveGameStateChange', message:newStates, p2p:options.p2p});
		} catch (e) {
			catchAWave.socketFailed();
		}
	},
	connectToPlayer:function() {
		console.log('Catch A Wave - connectToPlayer');
		
		var data={};
		catchAWave.connectUpdateGameState({newStates:['MASTER_CONNECTING_TO_PLAYER_2'],ignoreRoom:true});	

		data.gameId=catchAWave._getGameId();
		
		catchAWave.connectToPlayerSetState({state:'sendingInvite'});
		
		if (!socketIo.isConnected()) {
			console.log('Catch A Wave - Socket IO Not Connected');
			catchAWave.connectToPlayerSetState({state:'Socket IO not connected, try refreshing the application.'});
			return false;
		}
		
		catchAWave.connectToPlayerSetState({state:'connecting'});

		// We send the invite and receive the channel back
		var url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=catchawave.sendInvite';
		otuApp.triggerAjaxPost(url,data, {
			responseType:'json',
				callback : function(json) {
				if (json.messages!==null) {
					catchAWave._reportMessages(json);
				} 
				//catchAWave.connectToPlayerSetState({state:'Sending the invite'});

				if (json.success 
						&& !catchAWave._exists('SLAVE1_INVITE_DECLINED_ALREADY_PLAYING')
						&& !catchAWave._exists('SLAVE1_INVITE_DECLINED_TO_BUSY')
						&& !catchAWave._exists('SLAVE1_INVITE_DECLINED_NOT_JOURNALLED')) {
					console.log('Catch A Wave - Invite Send, Cofirming reception');
					catchAWave.connectToPlayerSetState({state:'Confirming invite reception'});
				} 
			}
		})
		
	},
	connectInvite:function(message) {
		console.log('Catch A Wave - connectInvite');

		/*
		if (license.isStudent() && !otuApp.appUser.json.mission1.hasJournalledToday) {
			try {
				socketIo.emitMessageToRoom({roomId:message.roomId,event:'catchAWaveGameInviteDeclinedAutomatically', message:{newStates:['SLAVE1_INVITE_DECLINED_NOT_JOURNALLED']},p2p:false});
			} catch (e) {
				catchAWave.socketFailed();
			}
			return;
		}*/

		// if invites are disabled we reject with a message 
		if (otuApp.appState.templateParams.catchAWaveInvitesDisabled
					|| catchAWave.UIInviteDialogOpen
						|| catchAWave.UIInviteDialogOpen
							|| otuApp.getTemplateParams().catchAWaveInvitesDisabled) {
			try {
				socketIo.emitMessageToRoom({roomId:message.roomId,event:'catchAWaveGameInviteDeclinedAutomatically', message:{newStates:['SLAVE1_INVITE_DECLINED_TO_BUSY']},p2p:false});
			} catch (e) {
				catchAWave.socketFailed();
			}
			return;
		}
		
		// if we are already playing we decline the invite inmediately
		if (catchAWave.connectIsGameOn() || catchAWave.isSinglePlayerGameOn()) {
			try {
				socketIo.emitMessageToRoom({roomId:message.roomId,event:'catchAWaveGameInviteDeclinedAutomatically', message:{newStates:['SLAVE1_INVITE_DECLINED_ALREADY_PLAYING']},p2p:false});
			} catch (e) {
				catchAWave.socketFailed();
			}
			return;
		}
		
		catchAWave.connectInviteRoomId=message.roomId;
		catchAWave.UIInviteCancelled=false;
		catchAWave.UIInviteInProgress=true;
		otuApp.onFinishedLoading(function(){

			
			var data={};
			var url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=catchawave.connectInvite&jsonErrorOnly=1';

			data.gameId=message.gameId;
			
			otuApp.triggerAjaxPost(url,data,{
				callback(response) {
					
				}
			});				
		});

	
		
	},
	connectToPlayerSetState:function(options) {
		console.log('Catch A Wave - connectToPlayerSetState');

		var state=options.state;
		
		console.log(state);
		
		$('#connectState').html(options.state);
				
	},
	connectInviteAccept:function(options) {
		console.log('Catch A Wave - connectInviteAccept');


		var data={};
		
		catchAWave.UIInviteDialogOpen=false;
		
		console.log('Catch A Wave - GameId');
		console.log(options);
		
		data.gameId=options.gameId;
		
		catchAWave.resetUIValues();
		
		// we hide the modal dialog
		$('#modalCatchAWavenInvite').modal('hide');

		// We send the invite and receive the channel back
		var url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=catchawave.connectAcceptInvite';
		otuApp.triggerAjaxPost(url,data, {
			responseType:'json',
				callback : function(json) {
				if (json.messages!==null) {
					catchAWave._reportMessages(json);
				} 

				if (json.success) {
					// update the gameData;

					const store = getStore();
					const reduxState = store.getState()
					if ( reduxState.otuVision.onCall && !reduxState.otuVision.screenShared ) {
						store.dispatch( setDockToSide(true));
					}
					
					catchAWave.setGameData(json.data.gameData);					
					catchAWave.updateUIGameData();

					catchAWave.connectInviteRoomId=null;

					console.log('Catch A Wave - connectInviteAccept Success GameDate');
					console.log(json.data.gameData);
					
					// if successfull we can show the start level screen
					catchAWave.newGame({
						new2PlayerGameSlave:true,
						postOptions:{
							callback:function() {
								// we must queue 	
								console.log('Catch A Wave - connectInviteAccept NewGame Success');
								
								otuApp.fxQ.queue(function(next){
									catchAWave.connectEmitGameState( {newStates:['SLAVE1_INVITE_ACCEPTED']}, {p2p:false});

									next();
								})
								
							}
						}
					})
					
				}
			}
		})		
		
	},
	connectInviteDecline:function() {
		console.log('Catch A Wave - connectInviteDecline');

		catchAWave.UIInviteDialogOpen=false;
		
		var data={};
		
		data.gameId=catchAWave._getGameId();

		catchAWave.connectEmitGameState( {newStates:['SLAVE1_INVITE_DECLINED']}, {p2p:false, roomId:catchAWave.connectInviteRoomId});
		
		$('#modalCatchAWavenInvite').modal('hide');	
		
		// reset the invite room id so we no longer handle messages from this invite
		catchAWave.connectInviteRoomId=null;
		
	},
	connectIsMaster:function() {
		return (catchAWave.gameData.mode==catchAWave.modeTwoPlayerPrimary );		
	},
	connectIsSlave1:function() {
		return (catchAWave.gameData.mode==catchAWave.modeTwoPlayerSecondary);		
	},
	connectIsRoom:function(roomId) {
		if (typeof catchAWave.gameData.roomId!=='undefined') {
			return catchAWave.gameData.roomId==roomId;
		}
		return false;
	},
	/*
	 *  Verify the answer to a question
	 */
	verifyAnswer:function(data,callback) {
		console.log('Catch A Wave - verifyAnswer');

		// stop the clock
		catchAWave.stopClock();
		
		data.answerTime=catchAWave.answerTime.getTime();
		
		var url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=catchawave.verifyAnswer';
		
		// add the game ID
		data.gameId=catchAWave.gameData.id;
		
		// verify the answer
		otuApp.triggerAjaxPost(url,data, {
			responseType:'json',
			debug:false,
			callback : function(json) {
				if (json.messages!==null) {
					catchAWave._reportMessages(json);
				} 
				
				if (json.success) {
					console.log('Catch A Wave - verifyAnswer Success');

					var questionInfo=json.data.questionInfo;
					
					// we handle the callback of the shared question code
					if ($.isFunction(callback)) {
						callback(questionInfo);
					}

					// update the gameData;
					catchAWave.setGameData(json.data.gameData);	
					
					if (catchAWave.isSinglePlayerGame()) {
						catchAWave.updateUIGameData();
					}
					
					console.log('Catch A Wave - Verify Answer Response');
					console.log(questionInfo);
					
					if (questionInfo.correct || questionInfo.isNsggQuestion) {

						if (questionInfo.isNsggQuestion && !questionInfo.correct) {
							catchAWave.showWipeout();								
						}
						
						// we set the flexYourMuscleCreditAwarded flag
						if (questionInfo.chestOpenAwarded) {
							catchAWave.UIChestOpenAwardedFlag=true;						
						}
						
						// we set the flexYourMuscleCreditAwarded flag
						if (questionInfo.flexYourMuscleCreditAwarded) {
							catchAWave.UIflexYourMuscleCreditAwardedFlag=true;
						}
						
						if (catchAWave.isTwoPlayerGame()) {
							if (catchAWave.connectIsMaster())
								catchAWave.connectEmitGameState( {newStates:['MASTER_QUESTION_ANSWERED_RIGHT']});	
							if (catchAWave.connectIsSlave1())
								catchAWave.connectEmitGameState( {newStates:['SLAVE1_QUESTION_ANSWERED_RIGHT']});	
						}
					

						// if the question is answered correct we wait 5 seconds and go to the next question
						if (catchAWave.isSinglePlayerGame()) {
							catchAWave.setTimeout(function(){
								if (catchAWave.UIChestOpenAwardedFlag) {
									catchAWave.UIChestOpenAwardedFlag=false;
									catchAWave.showAwardedOpenChest();
								} else								
								if (catchAWave.UIflexYourMuscleCreditAwardedFlag) {
									// if we awarded a flex your muscle credit we show it now
									catchAWave.UIflexYourMuscleCreditAwardedFlag=false;
									catchAWave.showAwardedAFlexYourMuscleCredit();
								} else {
									catchAWave.nextQuestion();
								}	
							},5000)
						}
						return;
					}
					

					
					// if the question is answered incorrect we wait 5 seconds and show the choosehowtocontinue screen
					if (questionInfo.correct===false) {
						catchAWave.showWipeout();

						if (catchAWave.isTwoPlayerGame()) {
							if (questionInfo.answerTimeOut) {
								if (catchAWave.connectIsMaster())
									catchAWave.connectEmitGameState( {newStates:['MASTER_QUESTION_ANSWERED_TOO_LATE']});	
								if (catchAWave.connectIsSlave1())
									catchAWave.connectEmitGameState( {newStates:['SLAVE1_QUESTION_ANSWERED_TOO_LATE']});
							
							} else {
								if (catchAWave.connectIsMaster())
									catchAWave.connectEmitGameState( {newStates:['MASTER_QUESTION_ANSWERED_WRONG']});	
								if (catchAWave.connectIsSlave1())
									catchAWave.connectEmitGameState( {newStates:['SLAVE1_QUESTION_ANSWERED_WRONG']});	
								}
						}
						
						catchAWave.setTimeout(function(){
							catchAWave.chooseHowToContinue();
						},5000)
						return;
					}
					
					
				}	
				
			}
		
		});	
	
		
	},
	/*
	 *  Verify the answer to a Flex Your Muscle Question question
	 */
	verifyFlexYourMuscleAnswer:function(data,callback) {
		console.log('Catch A Wave - verifyFlexYourMuscleAnswer');
		
		// stop the clock
		catchAWave.stopClock();
		
		data.answerTime=catchAWave.answerTime.getTime();
		
		var url = otuApp.appState.rootUrl + 'index.php?component=com_otu_op&task=catchawave.verifyFlexYourMuscleAnswer';
		
		// add the game ID
		data.gameId=catchAWave.gameData.id;
		
		// verify the answer
		otuApp.triggerAjaxPost(url,data, {
			responseType:'json',
			callback : function(json) {
				if (json.messages!==null) {
					catchAWave._reportMessages(json);
				} 
				
				if (json.success) {
					console.log('Catch A Wave - verifyFlexYourMuscleAnswer Success');

					var questionInfo=json.data.questionInfo;
					
					// we handle the callback of the shared question code
					if ($.isFunction(callback)) {
						callback(questionInfo);
					}

					// update the gameData;
					catchAWave.setGameData(json.data.gameData);					
					catchAWave.updateUIGameData();
					
					console.log('Catch A Wave - verifyFlexYourMuscleAnswer Response');
					console.log(questionInfo);
					
					if (questionInfo.correct) {
						// if answered correct we wait 5 seconds and go to the next question
						if (catchAWave.isTwoPlayerGame()) {
							
								if (catchAWave.connectIsMaster())
									catchAWave.connectEmitGameState( {newStates:['MASTER_FLEX_QUESTION_ANSWERED_RIGHT','MASTER_CONTINUES']});	
								if (catchAWave.connectIsSlave1())
									catchAWave.connectEmitGameState( {newStates:['SLAVE1_FLEX_QUESTION_ANSWERED_RIGHT','SLAVE1_CONTINUES']});	
						}
						
							// if the question is answered correct we wait 5 seconds and go to the next question
						if (catchAWave.isSinglePlayerGame()) {
							catchAWave.setTimeout(function(){
									catchAWave.nextQuestion();
								},5000)
								return;
						}
					}	
					
					
					
	
					// if the question is answered incorrect we wait 5 seconds and show the choosehowtocontinue screen
					if (questionInfo.correct===false) {
						catchAWave.showWipeout();

						if (catchAWave.isTwoPlayerGame()) {
							if (questionInfo.answerTimeOut) {
								if (catchAWave.connectIsMaster())
									catchAWave.connectEmitGameState( {newStates:['MASTER_FLEX_QUESTION_ANSWERED_TOO_LATE']});	
								if (catchAWave.connectIsSlave1())
									catchAWave.connectEmitGameState( {newStates:['SLAVE1_FLEX_QUESTION_ANSWERED_TOO_LATE']});
							
							} else {
								if (catchAWave.connectIsMaster())
									catchAWave.connectEmitGameState( {newStates:['MASTER_FLEX_QUESTION_ANSWERED_WRONG']});	
								if (catchAWave.connectIsSlave1())
									catchAWave.connectEmitGameState( {newStates:['SLAVE1_FLEX_QUESTION_ANSWERED_WRONG']});	
								}
						}						
						
						
							catchAWave.setTimeout(function(){
								catchAWave.chooseHowToContinue();
							},5000)
							return;
					}			
										
					
				}	
				
			}
		
		});	
	
		
	},	
	
	/*
	 * helper to get the gameId if set from the gameData property
	 */
	_getGameId:function () {
		if ((((catchAWave || {}).gameData || {}).id)) {
		 return catchAWave.gameData.id;
		}
		return null;
	},
	socketFailed : function() {
		this._reportMessages({
			messages : [ ["<b class='text-color-red'>Having trouble to connect to the Game Server, please try again later...</b>"]]
		})
	},
	clearMessages : function () {
		$('#catchAWaveMessages').empty();
	},
	/*
	 * Shows messages in the #catchAWaveMessages div
	 */
	_reportMessages:function(json){
		//console.log(json);.
		$('#catchAWaveMessages').empty()
		$.each(json.messages,function(key,value) {
			console.log(key);
			console.log(value);

			$.each(value,function (sKey,sValue) {
				$('#catchAWaveMessages').append('<p>' + sValue + '</p>');
			});
		});
	}
	
	
	
}